<div class="event-detail-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    <span class="title dialog-title">
      @if (event) {
        {{'event.event_detail' | translate}}
      }
      @if (elearning) {
        {{'elearning.detail' | translate}}
      }
    </span>
    <button mat-button class="mat-icon-button"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  <!--    </div>-->
</mat-toolbar>

<div class="p-24 m-0 content">
  @if (event) {
    <event-description [event]="event.event"></event-description>
  }
  @if (elearning) {
    <elearning-detail [elearning]="elearning.elearning"></elearning-detail>
  }
</div>

<div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
  <button class="mat-accent" mat-raised-button (click)="subscribe()">
    {{'main.subscription' | translate}}
  </button>
</div>
</div>
